
import React, { PureComponent } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputSelect from '../../commons/form/InputSelect'
import { handleKeyDown } from '../../../util/utils'

class OrganizedUnitSaleOperationMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = {}
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      this.props.initialize(this.props.organizedUnitSaleOperation)
    }
  }

  submitDocument (values) {
    let languages = []
    Object.keys(values).map(item => {
      if (!!values[item] && typeof values[item] === 'object') {
        languages.push(values[item])
      }
    })
    const organizedUnitSaleOperation = {
      organizedUnitSaleOperationId: values.organizedUnitSaleOperationId,
      organizedUnitId: values.organizedUnitId,
      saleTypeId: values.saleTypeId,
      operationTypeId: values.operationTypeId
    }

    this.props.actions.submitOrganizedUnitSaleOperation(organizedUnitSaleOperation)
  }

  render () {
    const {
      t, handleSubmit,
      showModal,
      combos: { organizedUnitsAllCombo, saleTypeAllCombo, operationTypeAllCombo }
    } = this.props
    const tKey = 'MASTERS.OPERATION_TYPE_MASTERS.MODAL.'
    return (
      <Modal id="organizedUnitSaleOperationMasterModal" className="_nf" show={showModal} onHide={this.props.actions.closeOrganizedUnitSaleOperationMasterModal} backdrop={'static'}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitDocument.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={this.props.actions.closeOrganizedUnitSaleOperationMasterModal}>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="organizedUnitId"
                controlLabel={t(`${tKey}OU`)}
                placeholder={t(`${tKey}OU`)}
                valueKey="id"
                labelKey="value"
                options={organizedUnitsAllCombo}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="saleTypeId"
                controlLabel={t(`${tKey}SALE_TYPE`)}
                placeholder={t(`${tKey}SALE_TYPE`)}
                valueKey="id"
                labelKey="value"
                options={saleTypeAllCombo}
              />
              <Field
                component={InputSelect}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                name="operationTypeId"
                controlLabel={t(`${tKey}OPERATION_TYPE`)}
                placeholder={t(`${tKey}OPERATION_TYPE`)}
                valueKey="id"
                labelKey="value"
                options={operationTypeAllCombo}
              />
              <div className='flexInLine al-L'>

              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div sm={12} className="flexInLine al-R">
              <Button
                id="role-modal-submit-button"
                className="_Btn new"
                type="submit"
                disabled={this.props.pristine}>
                {t(`${tKey}SUBMIT_BUTTON`)}
              </Button>
              <Button
                id="role-modal-submit-button"
                className="_Btn cancel"
                type="reset"
                onClick={this.props.actions.closeOrganizedUnitSaleOperationMasterModal}
                disabled={this.props.pristine}>
                {t(`${tKey}CANCEL_BUTTON`)}
              </Button>

            </div>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'editOrganizedUnitSaleOperation',
  validate: (values, props) => {
    let error = {}
    const tKey = 'MASTERS.OPERATION_TYPE_MASTERS.VALIDATION.'
    if (!values.saleTypeId) {
      error.saleTypeId = props.t(`${tKey}SALE_TYPE`)
    }
    return Object.keys(error).length > 0 ? error : {}
  }
})(OrganizedUnitSaleOperationMasterModal)
